const { Core, Events, Cache } = Global;
const SECRET_LOWER = 6700;
const SECRET_UPPER = 7000;
const { $fetch, $replaceContent, $toggleDisplay } = Global.Utils;


customElements.define('free-shipping-progress-bar', class extends Core {
    propTypes = {
        'cart-amount': Number,
        'free-shipping-amount': Number,
        'backpack-amount': Number,
        'hoodie-in-cart': Boolean,
        'hide-on-complete': Boolean
    }

    elements = {
        $: [
            'progress',
            'msg-eligible',
            'msg-eligible-secret',
            'msg-shortage',
            'msg-hoodie-close',
            'msg-shipping-only',
            'msg-both',
            'msg-thanks',
            'end-tick'
        ],
    }

    render() {
        this.rate = Shopify.currency.rate || 1;
        this.total = this.prop('cart-amount');
        this.shippingThreshold = this.prop('free-shipping-amount') * this.rate;
        this.backpackThreshold = (this.prop('backpack-amount') || 20000) * this.rate;
        this.shippingDiff = this.shippingThreshold - this.total;
        this.backpackDiff = this.backpackThreshold - this.total;
        const inSecretZone = this.total >= SECRET_LOWER && this.total < SECRET_UPPER;
        this._isSecret = inSecretZone;
        this.freeShipping = this.shippingDiff <= 0 || inSecretZone;
    }

    set freeShipping(isFree) {
        const backpackUnlocked = this.total >= this.backpackThreshold;
        const hoodieClose = this.backpackDiff > 0 && this.backpackDiff <= 300;

        $toggleDisplay(this.$('msg-eligible'), false);
        $toggleDisplay(this.$('msg-eligible-secret'), isFree && this._isSecret);
        $toggleDisplay(this.$('msg-shortage'), !isFree && !this._isSecret && !hoodieClose);
        $toggleDisplay(this.$('msg-hoodie-close'), hoodieClose && !this._isSecret);
        $toggleDisplay(this.$('msg-shipping-only'), isFree && !backpackUnlocked && !this._isSecret && !hoodieClose);
        $toggleDisplay(this.$('msg-both'), isFree && backpackUnlocked && !this._isSecret);
        $toggleDisplay(this.$('end-tick'), isFree && !this._isSecret);
        $toggleDisplay(this.$('msg-thanks'), isFree && this._isSecret);

        if (isFree && this._isSecret && !sessionStorage.getItem('fspb-secret-fired')) {
            sessionStorage.setItem('fspb-secret-fired', '1');
            this._confetti();
        }

        if (this.prop('hide-on-complete')) {
            $toggleDisplay(this.$('progress'), !isFree);
        }

        const targetProgress = Math.min(this.progress, 100);
        const inner = this.$('progress').querySelector('[class*="progress-inner"]');
        if (inner) {
            const startWidth = parseFloat(sessionStorage.getItem('shipping-bar-progress') || 0);
            const endWidth = targetProgress;
            sessionStorage.setItem('shipping-bar-progress', endWidth);
            const duration = 800;
            const startTime = performance.now();
            const animate = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
                inner.style.width = `${startWidth + (endWidth - startWidth) * ease}%`;
                if (progress < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
        } else {
            this.$('progress').style.setProperty('--progress', targetProgress);
        }

        if (!isFree && !hoodieClose) {
            const amountEl = this.$('msg-shortage').querySelector('[data-i18n-amount]');
            if (amountEl) amountEl.innerHTML = Shopify.formatMoney(this.shippingDiff);
        }

        if (isFree && !backpackUnlocked && !hoodieClose) {
            const amountEl = this.$('msg-shipping-only').querySelector('[data-i18n-backpack-amount]');
            if (amountEl) amountEl.innerHTML = Shopify.formatMoney(this.backpackDiff);
        }
    }

    get progress() {
        return Math.round(this.total * 100 / this.backpackThreshold);
    }
})
